'use server';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';
import { mediaExportJobRepository } from '@/contexts/media/repositories/MediaExportJobRepository';

export async function deleteExport(
  jobId: string,
): Promise<ActionResult<void>> {
  try {
    const familyId = await SessionService.getFamilyId();
    if (!familyId) return { success: false, error: 'Not authenticated' };

    // Verify ownership
    const job = await mediaExportJobRepository.getById(jobId);
    if (!job) return { success: false, error: 'Export not found' };
    if (job.familyId !== familyId) return { success: false, error: 'Access denied' };

    // Delete the object if present (real R2 delete). Accepts a key or legacy URL.
    const ref = job.resultUrl || job.videoUrl;
    if (ref) {
      try {
        const { getMediaStorage, objectKeyFromStored } = await import(
          '@/contexts/media/storage/StorageProvider'
        );
        await getMediaStorage().delete(objectKeyFromStored(ref));
      } catch {
        // Object deletion is best-effort — proceed with DB deletion even if removal fails
      }
    }

    await mediaExportJobRepository.delete(jobId);
    return { success: true, data: undefined };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('deleteExport', e) };
  }
}
